import { render, staticRenderFns } from "./CategoriesCreateModal.vue?vue&type=template&id=e81ba6c8&scoped=true"
import script from "./CategoriesCreateModal.vue?vue&type=script&lang=js"
export * from "./CategoriesCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81ba6c8",
  null
  
)

export default component.exports